export const REPORT_YEAR = 2022;
export const EMPLOYEE_REPORT_TYPE = 'employeeReport';
export const CONTRACTOR_REPORT_TYPE = 'contractorReport';
export const DATA_UPLOAD_METHOD = 'dataUploadMethod';
export const HRIS_INTEGRATION_METHOD = 'hrisIntegrationMethod';
export const ACCEPTED_FILE_TYPES = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];
export const GRAPHQL_QUERY_LIMIT = 200;
